(() => {
  if (window.ugPhotoWhite) return;
  const selector = 'img[data-ug-unified-fit]';
  const observed = new WeakSet(), states = new WeakMap(), cache = new Map(), jobs = new Map();
  let workerTask, sequence = 0, queue = Promise.resolve(), scheduled = false;
  async function getWorker() {
    if (!window.Worker || !window.OffscreenCanvas || !window.createImageBitmap) return null;
    if (!workerTask) workerTask = (async () => {
      const url = document.documentElement.dataset.ugPhotoMaskWorker;
      if (!url) return null;
      const response = await fetch(url,{cache:'force-cache'});
      if (!response.ok) return null;
      const objectURL = URL.createObjectURL(new Blob([await response.text()],{type:'text/javascript'}));
      const worker = new Worker(objectURL);
      URL.revokeObjectURL(objectURL);
      worker.onmessage = ({data}) => {
        const job = jobs.get(data.id);if(!job)return;
        jobs.delete(data.id);clearTimeout(job.timer);
        if(data.error) job.reject(new Error(data.error));
        else job.resolve(data.blob?URL.createObjectURL(data.blob):null);
      };
      worker.onerror = () => {
        jobs.forEach(job => {clearTimeout(job.timer);job.reject(new Error('Photo mask unavailable'));});
        jobs.clear();worker.terminate();workerTask=Promise.resolve(null);
      };
      return worker;
    })().catch(()=>null);
    return workerTask;
  }
  function getMask(url, includeWhite) {
    const key = url + '|' + includeWhite;
    if(cache.has(key))return cache.get(key);
    const task = queue.then(async () => {
      const worker = await getWorker();if(!worker)return null;
      const source = await new Promise((resolve,reject) => {
        const image = new Image();image.crossOrigin='anonymous';
        image.onload=()=>resolve(image);image.onerror=reject;image.src=url;
      });
      const bitmap = await createImageBitmap(source);
      return new Promise((resolve,reject)=>{
        const id=++sequence;
        const timer=setTimeout(()=>{jobs.delete(id);reject(new Error('Photo mask timeout'));},15000);
        jobs.set(id,{resolve,reject,timer});worker.postMessage({id,image:bitmap,includeWhite},[bitmap]);
      });
    });
    queue=task.catch(()=>null);cache.set(key,task);
    task.catch(()=>cache.delete(key));
    return task;
  }
  async function apply(image) {
    if(!image.isConnected || !image.complete || !image.naturalWidth)return;
    const url=image.currentSrc||image.src;
    if(!url || states.get(image)===url)return;
    states.set(image,url);
    image.style.removeProperty('mask-image');image.style.removeProperty('-webkit-mask-image');
    delete image.dataset.ugWhiteMask;
    try {
      const includeWhite = !!image.closest('#MainContent .card-wrapper:has(.price--ug-sale),#MainContent .ugx-card:has(.ugx-price--sale),#MainContent ug-sale-drop .ug-card');
      const mask=await getMask(url, includeWhite);
      if(!mask || !image.isConnected || states.get(image)!==url || (image.currentSrc||image.src)!==url)return;
      image.style.setProperty('mask-image','url("'+mask+'")');
      image.style.setProperty('-webkit-mask-image','url("'+mask+'")');
      image.dataset.ugWhiteMask='true';
    } catch(error) {states.delete(image);}
  }
  const visible=new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(entry.isIntersecting){apply(entry.target);visible.unobserve(entry.target);}
  }),{rootMargin:'250px'});
  function scan() {
    document.querySelectorAll(selector).forEach(image=>{
      if(observed.has(image))return;observed.add(image);
      image.addEventListener('load',()=>visible.observe(image));visible.observe(image);
    });
  }
  function schedule() {
    if(scheduled)return;scheduled=true;
    requestAnimationFrame(()=>{scheduled=false;scan();});
  }
  function start() {
    scan();
    new MutationObserver(records=>{
      records.forEach(record=>{
        if(record.type==='attributes' && record.target.matches(selector))visible.observe(record.target);
      });
      if(records.some(record=>record.type==='childList'||record.attributeName==='data-ug-unified-fit'))schedule();
    }).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['src','srcset','data-ug-unified-fit']});
    document.addEventListener('shopify:section:load',schedule);
  }
  window.ugPhotoWhite={scan:schedule};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
